import { Navigate, useParams, useSearchParams } from "react-router-dom";

/**
 * G-94 S4 — `/app/locations/:id` now lands on the inventory page.
 *
 * The shop dashboard is gone; everything it did happens on `/app/inventory`
 * with that shop picked. This keeps every old link working, and the query
 * string is CARRIED, which is the load-bearing part: G-83's create-then-receive
 * flow arrives as `?receiveForStock=<item>` and G-92's phone action sheet
 * deep-links the same way. Dropping the query here would silently break the
 * flow the owner asked for two days before this order.
 *
 * `replace`, so Back does not bounce the person off the page they just landed
 * on and straight back into the redirect.
 */
export function LocationRedirect() {
  const { locationId } = useParams();
  const [searchParams] = useSearchParams();

  if (!locationId) return <Navigate to="/app/inventory" replace />;

  const params = new URLSearchParams(searchParams);
  params.set("locationId", locationId);
  return <Navigate to={`/app/inventory?${params.toString()}`} replace />;
}
